import { render } from "./ShareLinkCommonCard.vue?vue&type=template&id=1da84202&scoped=true"
import script from "./ShareLinkCommonCard.vue?vue&type=script&lang=js"
export * from "./ShareLinkCommonCard.vue?vue&type=script&lang=js"

import "./ShareLinkCommonCard.vue?vue&type=style&index=0&id=1da84202&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da84202"]])

export default __exports__